import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Form } from "react-bootstrap";
import Range from '../components/Range'
import { useSelector, useDispatch } from "react-redux";

import profile from "../assets/defaultUser.png"
import email from "../assets/email.png"
import phone from "../assets/phone.png"
import lock from "../assets/lock.png"
import eye from "../assets/eye.png"
import eye_slash from "../assets/eye-slash.png"

import help_icon from "../assets/help-center-icon.png"
import BecomeAsellerBtn from '../components/BecomeAsellerBtn'
import AddEnergyBtn from '../components/AddEnergyBtn'
import { AUTOPURCHASE_DATA, AUTOPURCHASE_TOGGLE, UPD_PASSWORD, UPD_PROFILE, UPLOAD_PROFILE_PIC } from '../helpers/api'
import { SHA_Encryption } from "../helpers/token"
import UserModal from '../components/Modal';
import dateconversion from '../helpers/dateConversion';



function Profile() {
    const authUser = useSelector((state) => state.authReducer)
    const [logo, setLogo] = useState([]);
    const [showLogo, setShowLogo] = useState([]);

    const onSelectLogo = (event) => {
        const selectedFiles = event.target.files;
        setLogo((selectedFiles[0]))
        setShowLogo(URL.createObjectURL(selectedFiles[0]))

        // FOR BUG IN CHROME
        event.target.value = "";
    };

    function deleteLogo(image, e) {
        e.preventDefault();
        setLogo([]);
        URL.revokeObjectURL(image);
    }

    const store = [{
        logo: ""
    }]

    const [isChecked, setIsChecked] = useState(authUser.autopurchase);

    const handleToggle = () => {
        setIsChecked(!isChecked);
        autopurchaseToggle(!isChecked);
    }

    const autopurchaseToggle = async (status) => {
        try {
            const payload = {
                status
            }
            const response = await AUTOPURCHASE_TOGGLE(payload)

            if (response.success) {
                alert("updated")
            }
        }
        catch (e) {
            console.log(e);
        }
    }


    const [modalItem, setModalItem] = useState("");
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (modalItemValue) => { setShow(true); setModalItem(modalItemValue) };


    const updateMyProfilePic = async (e) => {
        e.preventDefault()
        try {
            const form = new FormData()
            form.append("cover1", logo);

            for (const entry of form.entries()) console.log(entry[0] + ':', entry[1]);

            const response = await UPLOAD_PROFILE_PIC(form)
            if (response.success) {
                alert("created")
                setLogo();
            }
        }
        catch (e) {
            console.log(e);
        }
    }


    const [cities, setCities] = useState([
        { "city": "London" },
        { "city": "Birmingham" },
        { "city": "Manchester" },
        { "city": "Leeds" },
        { "city": "Liverpool" },
        { "city": "Newcastle" },
        { "city": "Sheffield" },
        { "city": "Bristol" },
        { "city": "Nottingham" },
        { "city": "Southampton" },
        { "city": "Leicester" },
        { "city": "Edinburgh" },
        { "city": "Glasgow" },
        { "city": "Cardiff" },
        { "city": "Oxford" },
        { "city": "Cambridge" },
        { "city": "York" },
        { "city": "Bath" },
        { "city": "Brighton" },
        { "city": "Norwich" }

    ])



    return (
        <>
            <section className='profile_sec'>
                <div className="container">
                    <div className='content'>
                        <h3>Your Profile</h3>
                        <div className='d-flex profile jc-between ai-center mb-4'>
                            <div className='d-flex ai-center'>
                                <div className='profile-image'>
                                    <label className="mb-0">
                                        <div className="overlay">
                                            <span className="icon d-flex justify-content-around align-items-center w-40 text-center">
                                                <div>
                                                    <i className="fas fa-pen"></i>
                                                </div>
                                                {typeof logo !== "undefined" && logo?.length !== 0 ?
                                                    <>
                                                        <div onClick={(e) => deleteLogo(logo.image, e)}>
                                                            <i className="fas fa-trash"></i>
                                                        </div>
                                                        <div onClick={(e) => { updateMyProfilePic(e) }}>
                                                            <i className="fas fa-check"></i>
                                                        </div>
                                                    </>
                                                    :
                                                    ""
                                                }
                                            </span>
                                        </div>
                                        {typeof store[0]?.logo != 'undefined' && store[0].logo != "" ?
                                            <>
                                                {
                                                    logo?.length === 0 ?
                                                        <img src={showLogo} alt="logo" className="img-fluid me-4" />
                                                        :
                                                        <img src={profile} alt="logo" className="img-fluid me-4" />
                                                }
                                            </>
                                            :
                                            <>
                                                {
                                                    logo?.length === 0 ?
                                                        <img src={profile} alt="logo" className="img-fluid me-4" />
                                                        :
                                                        <img src={showLogo} alt="logo" className="img-fluid me-4" />
                                                }
                                            </>
                                        }
                                        <input type="file" name="" id="" style={{ display: "none" }} onChange={onSelectLogo} />
                                    </label>
                                </div>

                                <div>
                                    <h5>User 1</h5>
                                    <small>Member since 2022</small>
                                </div>
                            </div>
                            <div className='buttons d-flex ai-center'>
                                <BecomeAsellerBtn />
                            </div>
                        </div>

                        <div className="row ai-center">
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Username</label>
                                    <div className="form-inline">
                                        <input defaultValue={"User 1"} disabled type="text" className="form-control" placeholder='Alex' />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Email</label>
                                    <div className="form-inline d-flex ai-center">
                                        <div>
                                            <img src={email} alt="icon" className='img-fluid' />
                                        </div>
                                        <input disabled value={"user1@gmail.com"} type="email" className="form-control" placeholder='alexaandriana@gmail.com' />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Contact details</label>
                                    <div className="form-inline d-flex ai-center">
                                        <div>
                                            <img src={phone} alt="icon" className='img-fluid' />
                                        </div>
                                        <input type="text" className="form-control" placeholder='+12 3456 7890' />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Select Region</label>
                                    <div className="form-inline">
                                        <select className="form-select form-control" aria-label="Default select example">
                                            <option selected disabled>Choose your Location</option>
                                            {
                                                cities.map((item, i) => (
                                                    <option key={i} value={item?.city} >{item?.city}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className='update-buttons d-flex mt-5 mb-5'>
                                <button className='btn btn-update'>Update</button>
                            </div>
                        </div>

                        <h3>Update Password</h3>

                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Current Password</label>
                                    <div className="form-inline d-flex jc-between ai-center">
                                        <div>
                                            <img src={lock} alt="icon" className='img-fluid' />
                                        </div>

                                        <input type="password" className="form-control" placeholder='******' />
                                        <div>
                                            <img src={eye} alt="icon" className='img-fluid' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">New Password</label>
                                    <div className="form-inline d-flex jc-between ai-center">
                                        <div>
                                            <img src={lock} alt="icon" className='img-fluid' />
                                        </div>
                                        <input type="password" className="form-control" placeholder='******' />
                                        <div>
                                            <img src={eye} alt="icon" className='img-fluid' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="mb-3">
                                    <label className="form-label">Confirm Password</label>
                                    <div className="form-inline d-flex jc-between ai-center">
                                        <div>
                                            <img src={lock} alt="icon" className='img-fluid' />
                                        </div>
                                        <input type="password" className="form-control" placeholder='123456' />
                                        <div>
                                            <img src={eye} alt="icon" className='img-fluid' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='update-buttons d-flex mt-4 mb-5'>
                                <button className='btn btn-update'>Update</button>
                            </div>
                        </div>

                        <div className='d-flex ai-center'>
                            <h3 className='mb-0 me-2'>Auto Purchase</h3>
                            <div className='me-4 mt-2'>
                                {
                                    isChecked == true ?
                                        <small className='text-success fw-bold'>Active</small>
                                        :
                                        <small className='text-danger fw-bold'>Closed</small>

                                }
                            </div>
                            <Form>

                                <div className="d-flex align-items-center">
                                    <Form.Check
                                        type="switch"
                                        id="toggle-switch"
                                        label=""
                                        checked={isChecked}
                                        onChange={handleToggle}
                                    />
                                </div>

                            </Form>
                        </div>

                        <div className="row mb-4">
                            <div className="mb-3">
                                {
                                    isChecked == true &&
                                    <>

                                        <div className="row mt-4">
                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="mb-3">
                                                    <label className="form-label">Price</label>
                                                    <div className="form-inline d-flex jc-between ai-center">
                                                        <input type="text" className="form-control" placeholder='Price' disabled />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="mb-3">
                                                    <label className="form-label">Quantity</label>
                                                    <div className="form-inline d-flex jc-between ai-center">
                                                        <input type="text" className="form-control" placeholder='Quantity' disabled />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <UserModal btnText="Set / Update Energy" id="SetEnergy" customClasses="set_energy_btn mt-4" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow} >
                                            <div className='text-center mb-4'>
                                                <h3>Auto Purchase Details</h3>
                                            </div>
                                            <>
                                                <div className="mb-3">
                                                    <label className="form-label">Price</label>
                                                    <input type="number" placeholder='Enter here' className="form-control" />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label">Quantity</label>
                                                    <input type="number" placeholder='Enter here' className="form-control" />
                                                </div>
                                                <div className='text-center mt-5'>
                                                    <button className="btn energy_modal_btn">Submit</button>
                                                </div>
                                            </>
                                        </UserModal>

                                    </>

                                }

                            </div>

                        </div>

                        <div>
                            <Link to="/help-center" className='btn-help d-flex m-auto jc-center ai-center' style={{ textDecoration: "none" }}>
                                <span className='me-2'>Help</span>
                                <img src={help_icon} alt="icon" className='img-fluid' />
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Profile
